/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_Empty_PanelInputs */

const cs_clients_roles_empty_panel = /** @type {(inputs: Clients_Roles_Empty_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapněte odpovídající roli pro tuto sekci.`)
};

const en_clients_roles_empty_panel = /** @type {(inputs: Clients_Roles_Empty_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on a matching role to use this section.`)
};

/**
* | output |
* | --- |
* | "Turn on a matching role to use this section." |
*
* @param {Clients_Roles_Empty_PanelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_empty_panel = /** @type {((inputs?: Clients_Roles_Empty_PanelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_Empty_PanelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_empty_panel(inputs)
	return cs_clients_roles_empty_panel(inputs)
});